// extracted by mini-css-extract-plugin
module.exports = {"card":"GroupModal_card__DsHfk","box":"GroupModal_box__h6dbT"};